import PLAYTECHLIVEActions from './PLAYTECHLIVEActions'

export default class PLAYTECHEGAMEActions extends PLAYTECHLIVEActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'EGAME',
      gameCode: 'PLAYTECH-EGAME-001',
      platform: 'PLAYTECH',
    }

    this.gameName = "Pearl o' Plinko - Mermaid Cove"

    this.constantGameInfo = {
      betDetails: {
        tableCoverage: 0,
        betType: 'MAIN_BET',
      },
    }

    // roundId: 56_10221157746#07603d8c, 56_10221172324#07603d8c
    this.roundIdPrefix = '56'
    this.roundIdSufix = '07603d8c'

    // platformTxId: 29993029270, 29993553267
  }
}
